(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('easing', [function easingFactory() {
            /*
            * @param t - current time in transition. between 0 and d
            * @param b - starting value
            * @param c - value to transition to
            * @param d - total time of transition
            * @param s - ??
            *
            * using easing function for a transition should be called multiple times.
            * e.g. transitioning between 0 and 100 over 1000ms we could call
            *
            * easeInBack(0, 0, 100, 1000)
            * easeInBack(200, 0, 100, 1000)
            * easeInBack(400, 0, 100, 1000)
            * easeInBack(600, 0, 100, 1000)
            * easeInBack(800, 0, 100, 1000)
            * easeInBack(1000, 0, 100, 1000)
            */
            this.easeInBack = function (t, b, c, d, s) {
                if (s === undefined) {
                    s = 1.70158;
                }
                var retVal = c * (t /= d) * t * ((s + 1) * t - s) + b;
                return retVal;
            };

            this.easeOutBack = function (t, b, c, d, s) {
                if (s === undefined) {
                    s = 1.70158;
                }
                var retVal = c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
                return retVal;
            };

            this.easeInOutBack = function (t, b, c, d, s) {
                if (s === undefined) {
                    s = 1.70158;
                }
                var retVal;
                t /= d / 2;
                if (t < 1) {
                    retVal = c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
                } else {
                    retVal = c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
                }
                return retVal;
            };

            return this;
        }]);
}());
